import { canadaHowData } from "../../data/canadaTaxData";

export const CanadaHowSection = () => (
  <section id="how" className="py-24 px-6 bg-white">
    <div className="max-w-[87.5rem] mx-auto">
      <div className="mb-14">
        <span className="text-[#C8283A] text-xs font-black uppercase tracking-[0.2em] mb-3 block" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaHowData.sectionLabel}
        </span>
        <h2 className="text-[#0B1829] font-black leading-tight mb-3" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3rem)", letterSpacing: "-0.03em" }}>
          {canadaHowData.headline1}{" "}
          <span className="text-[#C8283A] italic">{canadaHowData.headline2}</span>
        </h2>
        <p className="text-[#5A6A7A] text-base max-w-md" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaHowData.sub}
        </p>
      </div>

      <div className="relative max-w-2xl flex flex-col gap-0">
        {/* Vertical line */}
        <div className="absolute left-[22px] top-10 bottom-10 w-[2px] bg-gradient-to-b from-[#D4A843] to-[#D4A843]/10" />

        {canadaHowData.steps.map((step, i) => (
          <div key={i} className="relative flex gap-8 pb-12 last:pb-0">
            {/* Step dot */}
            <div className="relative z-10 w-11 h-11 rounded-full bg-white border-2 border-[#D4A843] flex items-center justify-center flex-shrink-0 shadow-sm shadow-[#D4A843]/20">
              <span className="text-[#D4A843] font-black text-base" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {step.num}
              </span>
            </div>

            {/* Content */}
            <div className="pt-2">
              <h3 className="text-[#0B1829] font-black text-base mb-2" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {step.title}
              </h3>
              <p className="text-[#5A6A7A] text-sm leading-relaxed mb-3" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {step.body}
              </p>
              <div className="bg-[#F3F5F8] border border-[#E8ECF0] rounded-lg px-4 py-3">
                <p className="text-[#5A6A7A] text-xs leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                  <strong className="text-[#D4A843] font-bold">Note: </strong>
                  {step.detail}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
